import { RecordStatus, TranscriptsStatus, PROMPT_TAG, AiTaskStatus, KSO_AI, RecordViewPermissionRangeTextMap } from '@/constants/summary'
import { formatTime, formatDate, getOS, getUrlParam, addUrlParam } from '@/utils'
import { getTimeLabel, numberToChinese, havePrivilege, haveTrial, groupBySpeaker, caculateSpeakingTime, transformSpeakers } from '@/utils/summary'
import cloneDeep from 'lodash/cloneDeep'
import { Message } from '@kdocs/kdesign-vue'
import { meeting } from '@/utils/request'

const statusKeyMap = {
  record: 'record',
  transcripts: 'transcripts',
  ai_highlights_summary: 'aiHighLightsSummary',
  ai_chapters: 'aiChapters'
}


const defaultStatus = {
  record: {}, // 录制
  transcripts: {}, // 转写
  aiHighLightsSummary: {}, // 精华摘要
  aiChapters: {}, // 章节
}

export default {
  namespaced: true,
  state() {
    return {
      status: cloneDeep(defaultStatus),
      canManage: false,
      aiPrivilege: {},
      asrPrivilege: {},
      isMobile: false,
      showHeader: true,
      playbackRate: 1,
      textTrack: '',
      showTextTrack: true, // 是否显示字幕
      isQuanshi: false,
      updateTaskListKey: new Date().getTime(),
      modelSettingList: [],
      currentModelName: 'Kimi - 32k(默认)',
      systemPrompt: '',
      scheduleId: 0,
      allRecordList: [],
      transcripts: [],
      recordId: 0,
      allPromptList: [],
      aiQaList: [],
      // ai 助手聊天缓存
      chatList: [],
      chatAnswering: false,
      highlightsSummary: '',
      isEditHighlightsSummary: false,
      qaEditId: 0,
      permissions: [],
      summaryTemplate: undefined,
      aiQaListUpdateKey: new Date().getTime(),
      isExpandTranscripts: true,
      clientHeight: 0,
      transcriptsLoading: true,
      transcriptsActiveIndex: 0,
      mediaTime: 0,
      showDebugger: false,
      aiProvider: 'kimi',
      asrProvider: 'kimi',
      chapterProvider: 'kimi',
      recordNotFound: false,
      recordViewPermissionRange: '',
      title: '',
      chapterList: [],
      withoutRecord: true,
      meetingId: 0,
      recordInfo: {},
      mediaInfo: {},
      noPermission: false,
      speakers: [],
      testSpeaker: {
        speakerId: '',
        isWaitforPlaying: false,
        isPlaying: false,
        start: 0,
        end: 0,
      },
      newSpokesmanList: [],
      editSpeakerDialogVisible: false,
      minuteToken: '',
      minuteTokenExpired: 0,
      disabledAi: false,
      minuteTokenInvalid: false,
      shareUrl: '',
      shareLinkInfo: {}, // status 0 开启分享 1 关闭分享
      showShareSetting: false,
      applyStatus: undefined, // 0 未申请 1 申请中 2 已同意 3 已拒绝
      permissionMembers: [],
      shareLinkMembers: [],
      isSharePopupShow: false,
      highligntsSummaryView: 'default', // markdown, markmap
      qaAiProvider: '',
      multiRoundChat: false,
      deepThinking: false,
    }
  },
  getters: {
    haveAiPrivilege(state) {
      return havePrivilege(state.aiPrivilege)
    },
    haveAsrPrivilege(state) {
      return havePrivilege(state.asrPrivilege)
    },
    haveAiTrial(state) {
      return haveTrial(state.aiPrivilege)
    },
    haveAsrTrial(state) {
      return haveTrial(state.asrPrivilege)
    },
    transcriptsStatus(state) {
      return state.status.transcripts.status
    },
    isTranscriptsSuccess(state, getters) {
      return getters.transcriptsStatus === TranscriptsStatus.Success
    },
    recordStatus(state) {
      return state.status.record.status || RecordStatus.Running
    },
    aiChaptersStatus(state) {
      return state.status.aiChapters.status
    },
    aiHighLightsSummaryStatus(state) {
      return state.status.aiHighLightsSummary.status
    },
    isRecordSuccess(state, getters) {
      return getters.recordStatus === RecordStatus.Success
    },
    currentModelSetting(state) {
      const currentModel = state.modelSettingList.find(item => item.name === state.currentModelName) || {}
      return currentModel.value || {}
    },
    currentRecord(state) {
      return state.allRecordList.find(item => item.value === state.recordId) || {}
    },
    qaPrompt(state, getters) {
      return getters.promptList.find(item => item.tag === PROMPT_TAG.qa) || {}
    },
    shortcutQas(state, getters) {
      return getters.promptList.filter(item => item.tag === PROMPT_TAG.shortcut_qa) || []
    },
    shortcutBarQas(state, getters) {
      return getters.promptList.filter(item => item.tag === PROMPT_TAG.shortcut_bar) || []
    },
    formatedAiQaList(state) {
      return state.aiQaList.map((item, index) => {
        const updateTimeStamp = item.update_at * 1000
        return {
          ...item,
          updateTime: `${formatDate(updateTimeStamp, false)} ${formatTime(updateTimeStamp)}`,
          _index: numberToChinese(index + 1),
        }
      })
    },
    // 已经生成过Ai内容 或者 是管理者且有Ai权益  则展示AI内容
    showAiContent(state, getters) {
      if (state.disabledAi) return false
      const { aiHighLightsSummary } = state.status
      // const { userInfo } = rootState.account
      // const isPersonalUser = !userInfo?.is_company_account
      if (state.aiPrivilege.value === undefined || aiHighLightsSummary.status === undefined) {
        return false
      }
      return ((getters.haveAiPrivilege && state.canManage) || aiHighLightsSummary.status !== AiTaskStatus.NotStart)
    },
    // 已经生成过转写内容 或者 是管理者且有A转写权益则展示转写内容
    showAsrContent(state, getters) {
      return (getters.haveAsrPrivilege && state.canManage) || getters.transcriptsStatus !== TranscriptsStatus.NotStart
    },
    isIndependentTranscripts(state, getters) {
      return !getters.showAiContent
    },
    isCollapseTranscripts(state, getters) {
      return !getters.isIndependentTranscripts && !state.isExpandTranscripts
    },
    dwCommonParams(state, getters, rootState) {
      const { haveAiPrivilege, currentRecord } = getters
      const { userInfo } = rootState.account
      const company = userInfo?.corp || {}
      const timestamp = new Date().getTime()
      const mediaType = state.withoutRecord ? '' : (state.mediaInfo?.isAudio ? 'audio' : 'video')
      return {
        ai_privilege: haveAiPrivilege,
        meeting_id: currentRecord?.meeting_id || 0,
        record_id: state.recordId,
        link_id: getters.linkId || '',
        schedule_id: state.scheduleId || 0,
        url: window.location.href,
        version: 'v2.0',
        wps_user_id: userInfo?.id || 0,
        time: `${formatDate(timestamp)} ${formatTime(timestamp, true)}`,
        timestamp,
        company_id: company?.id || 0,
        company_name: company?.name || '',
        os_name: getOS(),
        media_type: mediaType,
      }
    },
    chapterFromTopic(state) {
      return state.summaryTemplate !== KSO_AI
    },
    promptList(state, getters) {
      const { aiProviderPromptList, generalPromptList } = getters
      const { summaryTemplate } = state
      if (summaryTemplate === '' || summaryTemplate === 'general') {
        return generalPromptList
      }
      return aiProviderPromptList.filter(item => item.scene === summaryTemplate) || []
    },
    aiProviderPromptList(state) {
      const { allPromptList, aiProvider } = state
      const promptList = allPromptList.filter(item => item.ai_provider === aiProvider) || []
      return promptList
    },
    generalPromptList(state, getters) {
      const { aiProviderPromptList } = getters
      return aiProviderPromptList.filter(item => item.scene === 'general') || []
    },
    viewPermissionRangeOptions(state) {
      const { scheduleId } = state
      const options = Object.keys(RecordViewPermissionRangeTextMap).map(item => {
        return {
          value: item,
          label: RecordViewPermissionRangeTextMap[item]
        }
      })
      return scheduleId ? options : options.filter(item => ['owner', 'meeting', 'company'].includes(item.value))
    },
    isInterview(state) {
      return state.summaryTemplate === 'interview'
    },
    withoutAsrAndAi(state, getters) {
      return !getters.showAsrContent && !getters.showAiContent
    },
    linkId(state) {
      if (state.shareUrl) {
        return  getUrlParam(state.shareUrl, 'link_id')
      }
      return ''
    },
    shareLink(state) {
      if (process.client) {
        let link = state.shareUrl
        const kmt_channel = getUrlParam(window.location.href, 'kmt_channel')
        if (kmt_channel) {
          link = addUrlParam(state.shareUrl, 'kmt_channel', kmt_channel)
        }
        return link
      }
      return ''
    },
    disabeldChangeRecord(state) {
      if (process.client) {
        const linkId = getUrlParam(window.location.href, 'link_id')
        const disabeldChangeRecord = !!linkId || state.withoutRecord
        return disabeldChangeRecord
      }
      return true
    },
    spokesmanList(state) {
      const { transcripts } = state
      const spokesmanList = groupBySpeaker(transcripts)
      const { speakingTime } = caculateSpeakingTime(transcripts)
      spokesmanList.forEach(spokesman => {
        spokesman.speakingPercent = speakingTime[spokesman.speaker].percent
      })
      spokesmanList.sort((a, b) => {
        return speakingTime[b.speaker].duration - speakingTime[a.speaker].duration
      })
      return spokesmanList
    },
    aiProviders(state) {
      return (state.recordInfo?.ai_providers || []).map(item => {
        return {
          value: item.provider,
          label: item.title,
          model: item.model,
          key: `${item.provider}::${item.model}`
        }
      })
    }
  },

  actions: {
    async getAiQaList({ commit, state }) {
      try {
        const { data } = await meeting.get('/api/v1/meeting_summary/transcripts/qa/list', {
          params: { record_task_id: state.recordId }
        })
        commit('setAiQaList', data.data || [])
      } catch (e) {
        console.error(e)
      }
    },
    async getPromptList({ commit }) {
      try {
        const { data } = await meeting.get('/api/v1/ai/prompt/list')
        const promptList = data.data || []
        commit('setAllPromptList', promptList)
      } catch (error) {
        console.log(error)
      }
    },
    async addAiQa({ commit, state }, data) {
      try {
        const { data: res } = await meeting.post('/api/v1/meeting_summary/transcripts/qa', {
          record_task_id: state.recordId,
          ...data
        })
        if (res.code === 0) {
          commit('addAiQa', res.data)
        }
        return res
      } catch (e) {
        console.error(e)
      }
    },
    async addShortcutQa({ getters, dispatch }, data) {
      try {
        const { name, prompt } = data
        const { data: res } = await meeting.post('/api/v1/ai/user/prompt', {
          refer_prompt_id: getters.qaPrompt.id,
          tag: PROMPT_TAG.shortcut_qa,
          name,
          prompt,
        })
        setTimeout(() => {
          dispatch('getPromptList')
        }, 600)
        return res
      } catch (e) {
        console.error(e)
      }
    },
    async editShortcutQa({ dispatch }, data) {
      try {
        const { data: res } = await meeting.put('/api/v1/ai/user/prompt', {
          prompt_id: data.id,
          name: data.name,
          prompt: data.prompt,
        })
        setTimeout(() => {
          dispatch('getPromptList')
        }, 600)
        return res
      } catch (e) {
        console.error(e)
      }
    },
    async delShortcutQa({ dispatch }, data) {
      try {
        const { data: res } = await meeting.delete(`/api/v1/ai/user/prompt?prompt_id=${data.id}`)
        if (res.code === 0) {
          setTimeout(() => {
            dispatch('getPromptList')
          }, 600)
        }
        return res
      } catch (e) {
        console.error(e)
      }
    },
    async getAiRecordStatus({ commit, state }, type) {
      try {
        const { data } = await meeting.get('/api/v1/record/status', {
          params: {
            record_task_id: state.recordId,
            tasks: type || 'record,transcripts,ai_highlights_summary,ai_chapters',
            summary_template: state.summaryTemplate,
          }
        })
        if (type) {
          commit('updateStatus', {
            key: statusKeyMap[type],
            value: data.data[type]
          })
          return {}
        } else {
          const res = { ...data.data }
          commit('setStatus', res)
          return res
        }
      } catch (error) {
        return {}
      }
    },
    async retryChapter({ state }) {
      try {
        await meeting.get('/api/v1/meeting_summary/transcripts/chapters', {
          params: {
            record_task_id: state.recordId,
            renew: true,
            summary_template: state.summaryTemplate,
            ai_provider: state.aiProvider
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    async getAiRecordDetail({ commit, state, dispatch }, recordId) {
      let recordNotFound = false
      let noPermission = false
      try {
        const { data } = await meeting.get('/api/v1/meeting_summary/detail', { params: { record_task_id: recordId } })
        if (data.code === 0) {
          const {
            title, user_permission_range, summary_template, schedule_id, meeting_id, has_record_media, ai_disable, share_url,
            ai_provider, asr_provider, chapter_ai_provider, record_view_permision_range, record_view_permission_range,
          } = data.data
          commit('setDisabledAi', ai_disable)
          commit('setRecordTitle', title)
          commit('setCanManage', user_permission_range === 'manageable')
          commit('setRecordViewPermissionRange', record_view_permission_range || record_view_permision_range)
          commit('setSummaryTemplate', summary_template || 'general')
          commit('setAiProvider', ai_provider)
          commit('setAsrProvider', asr_provider)
          commit('setChapterProvider', chapter_ai_provider)
          commit('setMeetingId', meeting_id)
          commit('setWithoutRecord', !has_record_media)
          commit('setRecordInfo', { ...data.data })
          if (!state.scheduleId) {
            commit('setScheduleId', schedule_id)
          }
          commit('setRecordNotFound', false)
          recordNotFound = false
          commit('setShareUrl', share_url || '')
        } else if (data.code_desc === 'PermissionDenied') {
          commit('setNoPermission', true)
          await dispatch('getShareLinkInfo')
          noPermission = true
        } else if (data.code_desc === 'TokenInvalid') {
          commit('setMinuteTokenInvalid', true)
        } else {
          commit('setRecordNotFound', true)
          recordNotFound = true
        }
      } catch (error) {
        recordNotFound = true
        console.log(error)
      }
      return {
        noPermission,
        recordNotFound
      }
    },
    async fetchHighlightSummary({ commit, state, getters }) {
      if (getters.aiHighLightsSummaryStatus !== AiTaskStatus.Success) return
      try {
        const { data } = await meeting.get('/api/v1/meeting_summary/transcripts/highlights_summary', {
          params: { record_task_id: state.recordId, renew: false, summary_template: state.summaryTemplate }
        })
        if (data.code === 0) {
          const markdown = data?.data?.data || ''
          commit('setHighlightsSummary', markdown)
        } else {
          commit('setHighlightsSummary', '')
        }
      } catch (error) {
        commit('setHighlightsSummary', '')
      }
    },
    async fetchChapterList({ commit, state, getters }) {
      if (getters.aiChaptersStatus !== AiTaskStatus.Success) return
      let chapterList = []
      try {
        const { data } = await meeting.get('/api/v1/meeting_summary/transcripts/chapters', {
          params: {
            record_task_id: state.recordId,
            summary_template: state.summaryTemplate
          }
        })
        if (data.code === 0) {
          chapterList = (data?.data?.chapters || []).map(item => {
            const { title, start_time, content, end_time } = item
            return {
              title,
              time: getTimeLabel(start_time * 1000),
              content,
              start: start_time,
              startTime: getTimeLabel(start_time * 1000),
              endTime: getTimeLabel(end_time * 1000)
            }
          })
        } else {
          chapterList = []
        }
      } catch (error) {
        chapterList = []
      }
      commit('setChapterList', chapterList)
    },
    async getTranscripts({ commit, state, getters }, showLoading) {
      if (!getters.isTranscriptsSuccess) {
        commit('setTranscripts', [])
        commit('setTranscriptsLoading', false)
        return
      }
      if (showLoading) {
        commit('setTranscriptsLoading', true)
      }
      try {
        const { data } = await meeting.get('/api/v1/meeting_summary/transcripts', {
          params: {
            record_task_id: state.recordId
          }
        })
        const uniqueIds = []
        let speakers = {}
        data.data?.forEach(item => {
          if (!uniqueIds.includes(item['unique_id']) && item['unique_id']) {
            uniqueIds.push(item['unique_id'])
          }
        })
        if (uniqueIds.length) {
          const res = await meeting.get('/api/v1/meeting_summary/transcripts/speakers', {
            params: {
              unique_ids: uniqueIds.join(',')
            }
          })
          speakers = res.data.data || {}
        }
        commit('setSpeakers', Object.keys(speakers).map(key => speakers[key]).map(item => {
          return {
            ...item,
            uniqueId: item.unique_id
          }
        }))
        const transcripts = transformSpeakers(data.data || [], speakers)
        commit('setTranscripts', transcripts)
      } catch (error) {
        commit('setTranscripts', [])
      }
      commit('setTranscriptsLoading', false)
    },
    async renewHighlightSummary({ commit, state, dispatch }) {
      if (!state.canManage) return
      commit('updateStatus', {
        key: 'aiHighLightsSummary',
        value: {
          status: AiTaskStatus.Running,
          status_desc: $t('analyzing _the_transcription_content.')
        }
      })
      await meeting.get('/api/v1/meeting_summary/transcripts/highlights_summary', {
        params: {
          record_task_id: state.recordId,
          renew: true,
          summary_template: state.summaryTemplate,
          ai_provider: state.aiProvider
        }
      })
      dispatch('getAiRecordStatus', 'ai_highlights_summary')
    },
    async updatePermission({ state, dispatch }, type) {
      try {
        const params = {
          record_view_permission_range: type,
          ...(state.scheduleId ? {
              schedule_id: state.scheduleId,
              meeting_id: state.meetingId
            } : {
              meeting_id: Number(state.meetingId)
            }
          ),
        }
        const { data } = await meeting.put('/api/v1/meeting_summary/permission', params)
        if (data.code === 0) {
          Message.success(`${$t('view_permission_have_been_modified_to')}${$t(RecordViewPermissionRangeTextMap[type])}`)
          dispatch('getAiRecordDetail')
        } else {
          Message.error($t('operation_failed'))
        }
      } catch (error) {
        Message.error($t('operation_failed'))
      }
    },
    async getShareLinkInfo({ commit, dispatch }) {
      const { record_id, link_id } = this.$router.currentRoute.query
      if (!record_id && !link_id) return
      try {
        const { data } = await meeting.get('/api/v1/record/share_link/info', {
          params: {
            record_task_id: record_id,
            link_id
          }
        })
        if (data.code === 0) {
          commit('setShareLinkInfo', data.data)
          dispatch('getApplyStatus')
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getApplyStatus({ commit, getters }) {
      try {
        const { data } = await meeting.get(`/api/v1/record/share_link/member/apply_status?link_id=${getters.linkId}`)
        if (data.code === 0) {
          commit('setApplyStatus', data.data.status)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getPrivilege({ commit }) {
      const { data } = await this.$api.meeting.get('/api/v1/user/privilege/meeting')
      if (data.data) {
        const { kmeeting_ai, kmeeting_asr } = data.data
        commit('setAiPrivilege', kmeeting_ai)
        commit('setAsrPrivilege', kmeeting_asr)
      }
    },
    async autoGenerateSummary({ dispatch }) {
      try {
        const { data } = await this.$api.meeting.post('/api/v1/record/auto_repair_privilege', {
          record_task_id: this.recordId
        })
        if (data.code === 0 && data.data.success) {
          await dispatch('getAiRecordStatus')
        }
      } catch (error) {
        _weblog.error('自动生成摘要失败', error)
      }
    }
  },

  mutations: {
    setStatus(state, data) {
      const { ai_highlights_summary, ai_chapters, record, transcripts } = data
      state.status = {
        record,
        transcripts,
        aiHighLightsSummary: ai_highlights_summary,
        aiChapters: ai_chapters,
      }
    },
    updateStatus(state, data) {
      const { key, value } = data
      state.status[key] = value
    },
    setCanManage(state, data) {
      state.canManage = data
    },
    setAiPrivilege(state, data) {
      state.aiPrivilege = data
    },
    setAsrPrivilege(state, data) {
      state.asrPrivilege = data
    },
    setIsMobile(state, data) {
      state.isMobile = data
    },
    setShowHeader(state, data) {
      state.showHeader = data
    },
    setPlaybackRate(state, data) {
      state.playbackRate = data
    },
    setTextTrack(state, data) {
      state.textTrack = data
    },
    setShowTextTrack(state, data) {
      state.showTextTrack = data
    },
    setIsQuanshi(state, data) {
      state.isQuanshi = data
    },
    setUpdateTaskListKey(state) {
      state.updateTaskListKey = new Date().getTime()
    },
    setModelSettingList(state, data) {
      state.modelSettingList = data
    },
    addModelSetting(state, data) {
      state.modelSettingList.push(data)
    },
    deleteModelSetting(state, index) {
      state.modelSettingList.splice(index, 1)
    },
    setCurrentModelName(state, data) {
      state.currentModelName = data
    },
    setSystemPrompt(state, data) {
      state.systemPrompt = data
    },
    setAllRecordList(state, data) {
      state.allRecordList = data
    },
    setTranscripts(state, data) {
      state.transcripts = data
    },
    setRecordId(state, data) {
      state.recordId = data
    },
    setAllPromptList(state, data) {
      state.allPromptList = data
    },
    setAiQaList(state, data) {
      state.aiQaList = data
    },
    addAiQa(state, data) {
      state.aiQaList.push(data)
      state.aiQaListUpdateKey = new Date().getTime()
    },
    setChatList(state, data) {
      state.chatList = data
    },
    setChatAnswering(state, data) {
      state.chatAnswering = data
    },
    deleteAiQa(state, id) {
      state.aiQaList = state.aiQaList.filter(item => item.id !== id)
    },
    updateAiQaList(state, data) {
      state.aiQaList = state.aiQaList.map(item => {
        if (item.id === data.id) {
          return data
        }
        return item
      })
    },
    setHighlightsSummary(state, data) {
      state.highlightsSummary = data
    },
    setIsEditHighlightsSummary(state, data) {
      state.isEditHighlightsSummary = data
    },
    setQaEditId(state, id) {
      state.qaEditId = id
    },
    setPermissions(state, data) {
      state.permissions = data
    },
    setSummaryTemplate(state, data) {
      state.summaryTemplate = data
    },
    setIsExpandTranscripts(state, data) {
      state.isExpandTranscripts = data
    },
    setClientHeight(state, data) {
      state.clientHeight = data
    },
    setSummaryLayout(state, data) {
      state.summaryLayout = data
    },
    resetStatus(state) {
      state.status = cloneDeep(defaultStatus)
    },
    setTranscriptsLoading(state, data) {
      state.transcriptsLoading = data
    },
    setScheduleId(state, data) {
      state.scheduleId = data
    },
    setTranscriptsActiveIndex(state, data) {
      state.transcriptsActiveIndex = data
    },
    setMediaTime(state, data) {
      state.mediaTime = data
    },
    setShowDebugger(state, data) {
      state.showDebugger = data
    },
    setAiProvider(state, data) {
      state.aiProvider = data
    },
    setAsrProvider(state, data) {
      state.asrProvider = data
    },
    setChapterProvider(state, data) {
      state.chapterProvider = data
    },
    setRecordNotFound(state, data) {
      state.recordNotFound = data
    },
    setRecordViewPermissionRange(state, data) {
      state.recordViewPermissionRange = data
    },
    setRecordTitle(state, data) {
      state.title = data
    },
    setNoPermission(state, data) {
      state.noPermission = data
    },
    setChapterList(state, data) {
      state.chapterList = data
    },
    setWithoutRecord(state, data) {
      state.withoutRecord = data
    },
    setMeetingId(state, data) {
      state.meetingId = data
    },
    setRecordInfo(state, data) {
      state.recordInfo = data
    },
    setMediaInfo(state, data) {
      state.mediaInfo = data
    },
    setTestSpeaker(state, data) {
      state.testSpeaker = {
        ...state.testSpeaker,
        ...data
      }
    },
    addNewSpokesman(state, data) {
      state.newSpokesmanList.push(data)
    },
    resetNewSpokesman(state) {
      state.newSpokesmanList = []
    },
    setEditSpeakerDialogVisible(state, data) {
      state.editSpeakerDialogVisible = data
    },
    setMinuteToken(state, data) {
      state.minuteToken = data
    },
    setMinuteTokenExpired(state, data) {
      state.minuteTokenExpired = Number(data)
    },
    setDisabledAi(state, data) {
      state.disabledAi = data
    },
    setMinuteTokenInvalid(state, data) {
      state.minuteTokenInvalid = data
    },
    setSpeakers(state, data) {
      state.speakers = data
    },
    setShareUrl(state, data) {
      state.shareUrl = data
    },
    setShareLinkInfo(state, data) {
      state.shareLinkInfo = data
      const { share_url } = data
      this.commit('summary/setShareUrl', share_url)
    },
    setShowShareSetting(state, data) {
      state.showShareSetting = data
    },
    setApplyStatus(state, data) {
      state.applyStatus = data
    },
    setIsSharePopupShow(state, data) {
      state.isSharePopupShow = data
    },
    setHighligntsSummaryView(state, data) {
      state.highligntsSummaryView = data
    },
    setQaAiProvider(state, data) {
      state.qaAiProvider = data
    },
    setMultiRoundChat(state, data) {
      state.multiRoundChat = data
    },
    setDeepThinking(state, data) {
      state.deepThinking = data
    },
  },
}
